<template>
    <div>
        <div class="section01">
            <h3 class="head_layout">코로나19
                <span class="chart" style="cursor: pointer;"
                      @click.prevent="showCovidChartWin(true)"></span>
                <span class="plus" style="cursor: pointer;"
                      @click.prevent="goPage"></span>
                <span style="cursor: pointer;"
                    :class="isRolling ? 'stop' : 'play'"
                    @click.prevent="rollingChange"></span>
            </h3>
            <div class="today-weather">
                {{ latestCovidState.basdtVal | ymd }}
                {{ latestCovidState.val2 }}시
                {{ latestCovidState.val3 }}분 기준
            </div>
            <div class="corona-box-wrap">
                <div class="corona-inbox">
                    <p class="tit">
                        격리해제
                        <span class="f_blue">{{ latestCovidState.val5 | currency }}</span>명
                    </p>
                    <ul class="cont">
                        <li>
                            <span class="f_orenge">{{ latestCovidState.val9 | currency }}</span>명
                            <p>신규확진자</p>
                        </li>
                        <li>
                            <span class="f_orenge">{{ latestCovidState.val4 | currency }}</span>명
                            <p>누적확진자</p>
                        </li>
                    </ul>
                </div>
                <div class="corona-inbox">
                    <p class="tit">사망 <span>{{ latestCovidState.val8 | currency }}</span>명</p>
                    <ul class="cont covid">
                        <li><span>{{ latestCareCnt | currency }}</span>명<p>치료중</p></li>
                        <li><span>{{ latestCovidState.val6 | currency }}</span>명<p>재택치료자</p></li>
                    </ul>
                </div>
            </div>
        </div>
        <transition name="modal">
            <CovidChartWin v-if="isShowCovidChartWin" @close-covid-chart-win="showCovidChartWin(false)"/>
        </transition>
    </div>
</template>

<script>
import CovidChartWin from '@/views/realtime/CovidChartWin.vue';
import Covid19Mixin from '@/store/covid19.mixin.js';

export default {
    name: 'CovidSummary',
    props: {
        isRolling: {
            type: Boolean,
            default: true,
        }
    },
    data () {
        return {
            isShowCovidChartWin: false,
        }
    },
    methods: {
        showCovidChartWin (isShow) {
            this.isShowCovidChartWin = isShow

            if(isShow) {
                this.$emit('chart-activated');
            } else {
                this.$emit('chart-deactivated');
            }
        },
        rollingChange() {
            this.$emit('change-rolling-click');
        },
        goPage() {
            window.open('https://www.ep.go.kr/CmsWeb/viewPage.req?idx=PG0000004918', '_blank')
        }
    },
    mixins: [Covid19Mixin],
    components: {
        CovidChartWin,
    },
}
</script>
